export { ListGuiasEntregaNoRx } from "./list";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/list/index.ts